import { useEffect, useState } from "react";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import ChartTable from "@/components/ChartTable";

export default function History() {
  const [charts, setCharts] = useState([]);
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get("/charts", { params: status ? { status } : {} })
      .then((r) => setCharts(r.data))
      .finally(() => setLoading(false));
  }, [status]);

  return (
    <div className="p-6 md:p-10 max-w-6xl mx-auto" data-testid="history-page">
      <PageHeader title="My History" subtitle="All charts you have submitted." />

      <div className="flex gap-2 mb-4">
        {[
          ["", "All"], ["pending", "Pending"], ["in_audit", "In Audit"], ["completed", "Completed"],
        ].map(([v, l]) => (
          <button key={v || "all"} onClick={() => setStatus(v)}
                  data-testid={`filter-${v || "all"}`}
                  className={`text-sm px-3 py-1.5 rounded-lg border transition-colors ${
                    status === v ? "border-sky-500 bg-sky-50 text-sky-800" : "border-slate-200 text-slate-600 hover:bg-slate-50"
                  }`}>
            {l}
          </button>
        ))}
      </div>

      {loading ? <div className="text-slate-500 py-8 text-center">Loading…</div> :
        <ChartTable charts={charts} linkTo={(c) => `/charts/${c.id}`} emptyMsg="No charts yet — submit your first one." />}
    </div>
  );
}
